import React from "react";
import { SovosToolbarActions, SovosToolbarGroup } from "mosaic-react";
import { DefaultToolbar } from "colbi_web_ui/lib/components";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import DatagridExportButton from "../DatagridExportButton/DatagridExportButton";

const PackageAssociationToolbar = ({ defaultToolbarProps, toolbarProps }) => {
    const { downloadableQueries } = useGlobalValue();
    const { data } = toolbarProps || {};

    return (
        <SovosToolbarGroup sx={{ width: "100%" }}>
            <SovosToolbarGroup
                sx={{ flex: "1 1 auto", justifyContent: "flex-start", paddingRight: "10px" }}
            />
            <SovosToolbarGroup>
                <SovosToolbarActions>
                    {downloadableQueries?.length ? <DatagridExportButton data={data} /> : null}
                    <DefaultToolbar {...defaultToolbarProps} />
                </SovosToolbarActions>
            </SovosToolbarGroup>
        </SovosToolbarGroup>
    );
};

export default PackageAssociationToolbar;
